import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

// Attach auth token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aib_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function setToken(token) {
  if (token) localStorage.setItem("aib_token", token);
  else localStorage.removeItem("aib_token");
}

export function getToken() {
  return localStorage.getItem("aib_token");
}

export function setUser(user) {
  if (user) localStorage.setItem("aib_user", JSON.stringify(user));
  else localStorage.removeItem("aib_user");
}

export function getUser() {
  const raw = localStorage.getItem("aib_user");
  return raw ? JSON.parse(raw) : null;
}
